import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {NbDialogRef} from "@nebular/theme";

@Component({
  selector: 'ngx-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent implements OnInit, AfterViewInit {
  @Input() title?: string = '';
  @Input() message: string;
  @Input() allowDelete: boolean = true;
  @Input() okTitle?: string = 'COMMON.ACTIONS.CONFIRM';
  @Input() cancelTitle?: string = 'COMMON.ACTIONS.CANCEL';
  @Input() hideCancel?;

  constructor(protected ref: NbDialogRef<ConfirmDialogComponent>) {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    const cancelBtn = document.getElementById('dialogCancelBtn');
    if (cancelBtn) {
      cancelBtn.focus();
    }
  }

  close() {
    this.ref.close();
  }

  save() {
    this.ref.close('confirm');
  }
}
